import { createLocalStorageNamespace } from "./createLocalStorageNamespace";
import type {
  ImpactAnalysisData,
  LegalRepresentativeData,
} from "@/types/impact-analysis";

export type ImpactAnalysisSnapshot = {
  impactAnalysis: ImpactAnalysisData;
  reprezentantData: LegalRepresentativeData;
  art9Flag: boolean;
};

export const impactAnalysisSnapshotStore =
  createLocalStorageNamespace<ImpactAnalysisSnapshot>({
    namespace: "nis2_impact_analysis_snapshot",
  });
